import EventEmitter from 'events';
import { createContext, useContext } from 'react';

export type PixelStreamingStatus =
  | 'unknown'
  | 'ready'
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'error';

export interface IPixelStreamingContext {
  emitUIInteraction: ((value: unknown) => void) | null,
  descriptor: EventEmitter,
  isStreaming: boolean,
  status: PixelStreamingStatus,
  connect: () => void,
}

export const PixelStreamingContext = createContext<IPixelStreamingContext>({
  emitUIInteraction: null,
  descriptor: new EventEmitter(),
  isStreaming: false,
  status: 'unknown',
  connect: () => {},
});

export function usePixelStreamingContext() {
  const context = useContext(PixelStreamingContext);
  if (!context) {
    throw new Error('Context can only be used within a PixelStreamingContextProvider');
  }
  return context;
}
